module.exports = __webpack_public_path__ + "static/tab4-86b2d7d9b10553d73ecf7e8739342100.jpg";